export default {
  ERROR_PRODUCT_CLONE: 'An error occurred cloning the product. Please try again',
  ERROR_PRODUCT_CREATE: 'We experienced an error while creating a new product. Please try again.',
  ERROR_PRODUCT_DELETE: 'An error occurred deleting the product. Please try again',
  ERROR_PRODUCT_NOT_FOUND: 'We couldn\'t find the requested product. Please ensure you have entered the correct URL or ensure the product still exists.',
  ERROR_PRODUCT_SAVE: 'We experienced an error while saving your product. Please try again.',
  ERROR_UPLOAD_FILETYPE_RESTRICT: 'You can only upload JPEG, PNG and SVG files',
  ERROR_UPLOAD_MAX_FILELIMIT: 'You\'ve reached the maximum number of files that can be uploaded',
  ERROR_UPLOAD_MAX_FILESIZE: 'Each file must be smaller than 10MB',
  ERROR_UPLOAD_UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
  PRODUCT_CLONE_ASK: 'Are you sure you want to clone **%%**?',
  PRODUCT_CLONE_CONFIRM: 'Cloning **%%**?',
  PRODUCT_DELETE_ASK: 'Are you sure you want to delete **%%**?',
  PRODUCT_DELETE_CONFIRM: 'Deleting **%%**',
} as {
  [key: string]: string,
};
